<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="dialogVisible" ref="modal">     
        <div class="u-window qr-modal">           
            <div class="u-btn close" @click="destroyElement"></div>
            <div class="dialog-wrapper">
                <h5 class="title"></h5>
                <div class="msg-view">
                    <div class="img-view">
                        <div class="img" v-if="content"><QRcode width="200" height="200" :content="content" :load="false"></QRcode></div>
                    </div>
                    <p>截图分享你的专属二维码，快去邀请玩家绑定吧！</p>
                </div>

                <div class="u-btn ok" @click="destroyElement()"></div>
            </div>       
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>      
</template>

<script>
export default {
    data (){
        return {
            dialogVisible : false,
            iscopy : false,
            text : '请稍后……',
            shareTxt : '分享专属链接 开启助力',
            gid : '',
            mode : 1,
            ajax_error : false,
            content : '',         
        }
    },
    created (){
        document.body.style.overflow = 'hidden';
    },  
    methods : {
        destroyElement () {
            document.body.style.overflow = ''; // 出现滚动条
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },     
    },
}
</script>

<style lang="scss" scoped>
    @mixin boxStyle ( $screenWidth ){
        .dialog-view{
            z-index: 100;
        }
    
        .qr-modal{
            width: 620px;
            height: 580px;
            background-image: url(~@/assets/images/modal/bg-modal-qr.png);        
        }

        .title{
            width: 524px;
            height: 50px;
            margin: 0 auto 30px;
            background-image: url(~@/assets/images/modal/title-qr.png);  
        }

        .msg-view{
            text-align: center;
            margin: 20px auto;

            color: #4b4846;

            .img-view{
                position: relative;
                width: 318px;
                height: 318px;
                margin: 0 auto 24px;
                background-image: url(~@/assets/images/modal/qr-view.png);

                .img{
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    transform: translate(-50%,-50%);
                }
            }
        }

        .u-btn.ok{

            width: 207px;
            height: 55px;
            margin: 50px auto 0;
            background-image: url(~@/assets/images/modal/btn-ok.png);

            @if ( $screenWidth == 1600) {
                &:hover{
                    background-image: url(~@/assets/images/modal/btn-ok_hover.png);
                }
            }
        }         
    
    }
    
    
    @media screen and (min-width: 1000px){
        @include boxStyle( 1600 );
    }
    @media screen and (min-width: 375px) and (max-width: 999px){
        @include boxStyle( 1000 );
    }   
</style>


// WEBPACK FOOTER //
// src/components/QrModal/Modal.vue